import { FC, ReactNode, useEffect, useRef, useState } from 'react';
import { Button } from './styled';

export const ScrollToTop: FC<{
  children?: ReactNode;
  isTimelineOpen: boolean;
}> = ({ children, isTimelineOpen }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    /*window.addEventListener('scroll', (e) => {
      setVisible(ref.current!.getBoundingClientRect().top < 1);
    });
    return () => {
      window.removeEventListener('scroll', (e) => {
        setVisible(ref.current!.getBoundingClientRect().top < 1);
      });
    };*/
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(!entry.isIntersecting);
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  const handleButtonClick = () => {
    document.scrollingElement?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <div ref={ref}>{children}</div>
      <Button
        type="button"
        onClick={handleButtonClick}
        $isVisible={isVisible && isTimelineOpen}
      >
        <svg
          width="61"
          height="60"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M44.082 34L33.5445 23.4624"
            stroke="#161F24"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M22.2114 33.3424C21.8208 33.7329 21.8208 34.3661 22.2114 34.7566C22.6019 35.1471 23.235 35.1471 23.6256 34.7566L22.2114 33.3424ZM23.6256 34.7566L34.1976 24.1846L32.7834 22.7703L22.2114 33.3424L23.6256 34.7566Z"
            fill="#161F24"
          />
        </svg>
      </Button>
    </>
  );
};
